import { tv, type VariantProps } from "../../../util/tv";

export const institutionalCardsVariant = tv({
  slots: {
    base: ["relative", "py-12", "overflow-hidden"],
    gradient: ["gradient-circles"],
    wrapper: ["container-fluid"],
    content: [""],
    heading: ["max-w-2xl"],
    title: [],
    description: [],
    cards: ["flex flex-col lg:flex-row gap-4", "mt-12", "relative"],
  },
  variants: {
    theme: {
      dark: {
        base: ["bg-black"],
        title: ["text-blue-300"],
        description: ["text-gray-60"],
      },
      light: {
        base: ["bg-white"],
        title: ["text-blue-100"],
        description: ["text-gray-60"],
      },
    },
  },
  defaultVariants: {
    theme: "dark",
  },
});

export type InstitutionalCardsVariantProps = VariantProps<
  typeof institutionalCardsVariant
>;

export type InstitutionalCardsReturnVariantProps = ReturnType<
  typeof institutionalCardsVariant
>;
